import styled from 'styled-components'
import { mobile } from '../../styles/media'

const HavesOnImage = styled.div`
	position: absolute;
	bottom: 0.15rem;
	left: 0;

	background: ${props => props.havesInOtherSets ? props.theme.sage : 'rgba(0, 0, 0, 0.8)'};
	border-radius: 0 2px 2px 0;
	color: ${props => props.havesInOtherSets ? 'rgba(255, 255, 255, 0.7)' : '#FFF'};
	font-family: TechnaSans, ${props => props.theme.fontDefault};
	font-size: 1rem;
	font-weight: bold;
	letter-spacing: 1px;
	line-height: 1;
	text-shadow: ${props => props.havesInOtherSets ? '1px 1px 0 rgba(0, 0, 0, 0.2)' : '1px 1px 0 #000'};

	padding: 0.1rem 0.15rem;

	span {
		font-size: 0.9rem;
	}

	${props => !props.grid && !props.fullscreen && `
		top: calc(70px + 1.15rem);
		bottom: auto;
		left: 1rem;
	`}

	${props => !props.grid && props.fullscreen && `
		top: calc(70px + 1.15rem);
		bottom: auto;
		left: 0.5rem;
	`}

	${props => props.large && `
		font-size: 2.2rem;
		left: 0;
		top: auto;
		bottom: 2rem;

		span {
			font-size: 2.1rem;
		}
	`}

	${mobile`
		font-size: 0.9rem;

		span {
			font-size: 0.8rem;
		}

		${props => props.large && `
			font-size: 1.7rem;
			left: 0;
			top: auto;
			bottom: 1rem;

			span {
				font-size: 1.6rem;
			}
		`}
	`}
`

export default HavesOnImage
